<div class="AmBagsPassenger-container">
  <div class="AmBagsPassenger-detail">
    <p class="AmBagsPassenger-detail-name">
      {{ passenger?.displayName | titlecase }}
      <span class="gap-1 align-items-center"
            *ngIf="passenger.hasInfant">
      +1
      <img class="am-image-child" src="./assets/images/child.svg" alt="infant"/>
    </span>
    </p>

    <div *ngIf="passenger.bagsUsed?.length" class="animate__animated_1 animate__zoomIn animate__faster d-inline-block">
                  <span
                    *ngIf="passenger.bagsUsed?.length"
                    class="fs-18px">
                   {{ passenger.bagsUsed?.length }}
                   </span>
      <span  [ngClass]=" passenger.bagsUsed?.length > 0 ? fareFamilyTextColor : 'am-text-NoBags' ">
                    {{ "passengerSelection.passengerButton.bag_document2" | translate }}
      </span>
    </div>

    <p class="AmBagsPassenger-detail-club" *ngIf="passenger?.frequentFlyerNumber">
      {{ passenger?.frequentFlyerProgram | loyaltyPrograms }}: {{ passenger?.frequentFlyerNumber }}
    </p>
  </div>
</div>
